import React from 'react';
import { styles } from './SlapAdsRegistry.styles';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { useSlapAdsRegistryTranslations } from './SlapAdsRegistry.i18n';

interface SlapAdsRegistryProps {
  redirectTo: string;
}

const SlapAdsRegistry: React.FC<SlapAdsRegistryProps> = ({ redirectTo }) => {
  const { messageLine1, messageLine2, btn } = useSlapAdsRegistryTranslations();

  return (
    <Flex
      __css={styles.slapAdsRegistryWrapper}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      rowGap={6}
      borderRadius={5}
      backgroundColor="white"
      paddingX={6}
      paddingY={8}
    >
      <TextV2
        data-testid="slap-ads-registry-message"
        textAlign="center"
        color="mono14"
        typographyVariant="hed4"
        letterSpacing="normal"
        textTransform="none"
        fontWeight="semibold"
      >
        {messageLine1()}
        <br />
        {messageLine2()}
      </TextV2>
      <ButtonV2
        href={redirectTo}
        target="_blank"
        rel="noopener noreferrer"
        as="a"
        intent="neutral"
        shape="rounded"
        fontWeight="bold"
        fontSize={16}
        width="100%"
      >
        {btn()}
      </ButtonV2>
    </Flex>
  );
};

SlapAdsRegistry.displayName = 'SlapAdsRegistry';

export { SlapAdsRegistry };
